import React, {PureComponent} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import History from "@irati/utils/history"
import {injectIntl, FormattedMessage} from "@irati/utils/lang"
import padding from "@irati/ui/src/global/padding"
import {Para as ParaBase} from "@irati/ui/src/Labels"
import ButtonBase from "@irati/ui/src/Button"
import {H2} from "@irati/ui/src/Headings"
import Modal from "@irati/ui/src/Modal"

import modalImage from "../../images/ghost.png"

const Para = styled(ParaBase)`
  margin: ${padding.small} 0 ${padding.large};
`

const Button = styled(ButtonBase)`
  width: 100%;
`

class ErrorPopup extends PureComponent {
  state = {
    show: true
  }

  static contextTypes = {
    appPath: PropTypes.string.isRequired
  }

  handleHide = () => this.setState({
    show: false
  })

  handleAfterExit = () => {
    History.push("/reward", this.context)
  }

  handleClick = () => {
    History.push("/reward", this.context)
  }

  render() {
    const {show} = this.state

    return (
      <Modal show={show} image={modalImage} onHide={this.handleHide} onExited={this.handleAfterExit}>
        <H2>
          <FormattedMessage id="reward.popup.error.title" />
        </H2>
        <Para large center>
          <FormattedMessage id="reward.popup.error.description" />
        </Para>
        <Button primary type="button" onClick={this.handleClick}>
          <FormattedMessage id="reward.popup.error.button.label" />
        </Button>
      </Modal>
    )
  }
}

export default injectIntl(ErrorPopup)
